import * as isomorphicLocalStorage from 'lib/storage/isomorphicLocalStorage'

/**
 * Mustn't contain `loyalty-societe-rewards-` / `loyalty-tier-progress-snackbar-`, which are cleared
 * on logout — the notice must stay seen across logins.
 */
const STORAGE_PREFIX = 'loyaltyAutoEnrolledNoticeSeen:'

function getStorageKey(accountNumber: number) {
  return `${STORAGE_PREFIX}${accountNumber}`
}

export function hasSeenAutoEnrolledNotice(accountNumber: number): boolean {
  // Without persistent storage (SSR, privacy modes) "seen" can't survive a reload, so never show
  if (!isomorphicLocalStorage.isPersistent()) return true
  try {
    return !!isomorphicLocalStorage.get(getStorageKey(accountNumber))
  } catch {
    // Storage can fail in privacy modes — treat as seen so the notice can't show on every page load
    return true
  }
}

export function recordAutoEnrolledNoticeSeen(accountNumber: number): void {
  try {
    isomorphicLocalStorage.set(getStorageKey(accountNumber), new Date().toISOString())
  } catch {
    // Storage can fail in privacy modes or when quota is exhausted.
  }
}
